export default __webpack_public_path__ + "static/media/icon-netflix-addicted.c0525350.svg";